const ID_SPACE = 3;
const LOCALE = "fr-FR";
export { ID_SPACE, LOCALE }